import * as React from 'react';
import Div from "@jumbo/shared/Div";
import TopNavBar from 'app/components/TopNavBar/TopNavBar';
import ContentWrapper from 'app/components/ContentWrapper/ContentWrapper';
import ButtonStyled from 'app/components/ButtonStyled/ButtonStyled';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { Typography } from "@mui/material";
import { useNavigate } from 'react-router-dom';
import { requestApi } from 'app/utils/RestApi';
import { COMMON, REFERRER } from 'app/utils/constants/endPoint';
import Swal from 'sweetalert2';
import { connect } from 'react-redux';
import { b64toBlob } from 'app/utils/appHelpers';
import moment from 'moment';
import TncViewer from 'app/components/TncViewer';
import Footer from 'app/components/Footer';

const MicrositeSyaratKetentuan = (props) => {
	const navigate = useNavigate();
	const [agreement, setAgreement] = React.useState({});
	const [userdata, setUser] = React.useState({});

	const doAgree = async (e) => {
		navigate('/micrositeOtpLoggedIn')
		// await Swal.fire({
		// 	text: 'Please wait..',
		// 	timerProgressBar: true,
		// 	didOpen: () => {
		// 		Swal.showLoading()
		// 		requestApi(REFERRER.AGREE_TNC_REF, {
		// 			params: {
		// 				email: userdata.username
		// 			}
		// 		}).then(({ data }) => {
		// 			Swal.close();
		// 			if (data.status === 'success') {
		// 				Swal.fire({
		// 					icon: 'success',
		// 					text: 'Berhasil menyetujui TNC',
		// 					allowOutsideClick: true,
		// 					color: 'green'
		// 				})
		// 				let ls_user = {
		// 					...userdata,
		// 					isRegistered: true
		// 				}
		// 				setUser(ls_user)
		// 				localStorage.setItem('userdata', JSON.stringify(ls_user))
		// 			}
		// 		}).catch(err => {
		// 			Swal.close();
		// 			console.log(err);
		// 			setTimeout(() => {
		// 				Swal.fire({
		// 					icon: 'warning',
		// 					text: err.message,
		// 					allowOutsideClick: false,
		// 					confirmButtonColor: 'red'
		// 				})
		// 			}, 1000);
		// 		})
		// 	},
		// 	showCloseButton: false,
		// 	showConfirmButton: false,
		// 	allowOutsideClick: false
		// })
	};

	const goback = () => {
		navigate(-1);
	};

	React.useEffect(() => {
		document.querySelector("html").classList.add('overflow-hidden');
		if (localStorage.getItem('userdata')) {
			const ls_user = JSON.parse(localStorage.getItem('userdata'))
			setUser(ls_user)
		}
	}, []);

	React.useEffect(() => {
		if (userdata?.userLoggedin) {
			fetchTnc()
		}
	}, [userdata]);

	const fetchTnc = async () => {
		if (!userdata?.userLoggedin?.referrerCode) return

		const { data } = await requestApi(COMMON.TNC_REFERRER, {
			subfolder: "/" + userdata?.userLoggedin?.referrerCode
		})

		if (data?.status === 'success') {
			// setTncData(data.data.tnc)
			setAgreement(data.data);
		}
	}

	const download = async () => {
		await Swal.fire({
			title: 'Mohon Tunggu..',
			timerProgressBar: true,
			didOpen: () => {
				Swal.showLoading()
				requestApi(COMMON.TNC_DOWNLOAD, {
					params: {
						type: 1,
						code: userdata.userLoggedin.referrerCode
					}
				}).then(({ data }) => {
					Swal.close()
					if (data.data) {
						const blob = b64toBlob(data.data.base64File, "application/pdf");
						const blobUrl = URL.createObjectURL(blob);

						const downloadLink = document.createElement("a");
						document.body.appendChild(downloadLink);
						downloadLink.href = blobUrl;
						downloadLink.download = "SnK_Referral_Program_" + moment().format('DD-MM-YYYY-HH-mm') + '.pdf';
						downloadLink.style.display = "none";
						downloadLink.click();
						document.body.removeChild(downloadLink);
					}
				}).catch(err => {
					console.log(err);
					setTimeout(() => {
						Swal.fire({
							icon: 'warning',
							text: err.message,
							allowOutsideClick: false,
							confirmButtonColor: 'red'
						})
					}, 1000);
				})
			},
			showCloseButton: false,
			showConfirmButton: false,
			allowOutsideClick: false
		})
	}


	return (
		<Div className='page-wrapper'>
			<TopNavBar activeMenu={1} />
			<ContentWrapper>
				<Div className='content-padding'>
					<Div className='back-icon'>
						<KeyboardBackspaceIcon onClick={goback} />
					</Div>
					<Div className='flex-justify-center-title '>
						<Typography fontSize={24} fontWeight={600} color={"#C21B17"}>{(agreement?.tnc?.title) ?? ""}</Typography>
					</Div>


					{/* <Div className='mt-2'>
						<Div className='p-4'>
							<Typography fontSize={12} dangerouslySetInnerHTML={{ __html: (tncData.content) ? tncData.content : "" }}></Typography>
						</Div>
					</Div> */}
					<TncViewer content={agreement?.tnc?.content} date={userdata.isRegistered ? agreement?.referrer?.agreedDate : ""} batchNo={agreement?.batchNo} />

					{(userdata != undefined && !userdata.isRegistered) ? (
						<Div className='flex-justify-center' sx={{ mt: 2 }}>
							<ButtonStyled
								onClick={doAgree}
								btnText={"Setuju"}
								preset={"primary"}
								sx={{ maxWidth: '451px' }}
							/>
							<ButtonStyled
								onClick={goback}
								btnText={"Tidak Setuju"}
								preset={"secondary"}
								sx={{ maxWidth: '451px' }}
							/>
						</Div>
					)
						:
						<Div className='flex-justify-center' sx={{ mt: 2 }}>
							<ButtonStyled
								onClick={download}
								btnText={"Unduh"}
								preset={"primary"}
								sx={{ maxWidth: '451px' }}
							/>

						</Div>
					}
				</Div>
			</ContentWrapper>
			<Footer />
		</Div>

	);
};

const mapStateToProps = state => ({
	authMicrosite: state.authMicrosite
});

export default connect(mapStateToProps)(MicrositeSyaratKetentuan);